import axios from "axios";


const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACK,
});


// Function to handle 401 errors globally
function setupAxiosInterceptors(navigate, setOnline,showExpirationToast) {
  apiClient.interceptors.response.use(
    (response) => response, // Pass successful responses
    (error) => {
      if (error.response && error.response.status === 401) {
        
        
        // Clear token and user data on 401 errors
        const token = JSON.parse(localStorage.getItem('userToken'));
        
        if(token)
        {
          localStorage.removeItem("userToken");
          localStorage.removeItem("seo_app");
          setOnline(false);
          console.warn("Token expired or unauthorized. User is now a guest.");
          showExpirationToast("زمان مجاز لاگین شما در سرور منقضی شد. لطفاً مجددا لاگین کنید");
        }

        

        return Promise.reject(error);
      }
      return Promise.reject(error); // Pass other errors to the caller
    }
  );
}

export { apiClient, setupAxiosInterceptors };
